module.exports = __webpack_public_path__ + "images/landing/video-previews/success_preview_3_981_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/success_preview_3_981_2x.jpg
// module id = kr3B
// module chunks = 1